import { Fragment } from "react";

interface HighlightProps {
  text: string;
  keyword: string;
}

/**
 * 将文本中匹配关键词的部分高亮显示。
 */
export default function Highlight({ text, keyword }: HighlightProps) {
  const kw = keyword.trim();
  if (!kw) return <>{text}</>;

  const lowerText = text.toLowerCase();
  const lowerKw = kw.toLowerCase();
  const parts: Array<{ value: string; match: boolean }> = [];

  let cursor = 0;
  let idx = lowerText.indexOf(lowerKw, cursor);

  while (idx !== -1) {
    if (idx > cursor) {
      parts.push({ value: text.slice(cursor, idx), match: false });
    }
    parts.push({ value: text.slice(idx, idx + kw.length), match: true });
    cursor = idx + kw.length;
    idx = lowerText.indexOf(lowerKw, cursor);
  }
  if (cursor < text.length) {
    parts.push({ value: text.slice(cursor), match: false });
  }

  return (
    <>
      {parts.map((p, i) =>
        p.match ? (
          <mark key={i} className="bg-accent-200 text-accent-950 rounded px-0.5">
            {p.value}
          </mark>
        ) : (
          <Fragment key={i}>{p.value}</Fragment>
        )
      )}
    </>
  );
}